module.exports = __webpack_public_path__ + "img/Terraza con fogon.f240a316.png";